import ManageDocumentSignatureLink from "./containers/_Widgets/CustomWidgetLinks/DocumentSignatureLinks/ManageDocumentSignatureLink";
import MyDocumentsToSignLink from "./containers/_Widgets/CustomWidgetLinks/DocumentSignatureLinks/MyDocumentsToSignLink";
import OpenSurveysLink from "./containers/_Widgets/CustomWidgetLinks/EmployeeSurveysLinks/OpenSurveysLink";
import ProgressingSlowlyLink from "./containers/_Widgets/CustomWidgetLinks/EmployeeSurveysLinks/ProgressingSlowlyLink";
import OpenProviderPopupsLink from "./containers/_Widgets/CustomWidgetLinks/HelpAndTipsLinks/OpenProviderPopupsLink";
import RanOutOfPopusLink from "./containers/_Widgets/CustomWidgetLinks/HelpAndTipsLinks/RanOutOfPopupsLink";
import ClosedAlertLineLink from "./containers/_Widgets/CustomWidgetLinks/ManageAlertLineLinks/ClosedAlertLineLink";
import ManageAlertLineFooter from "./containers/_Widgets/CustomWidgetLinks/ManageAlertLineLinks/ManageAlertLineFooter";
import PendingAlertLineLink from "./containers/_Widgets/CustomWidgetLinks/ManageAlertLineLinks/PendingAlertLineLink";
import ManageLetterAddresseesLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/ManageLetterAddresseesLink";
import NoPendingMailsLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/NoPendingMailsLink";
import PendingIncomingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/PendingIncomingMailLink";
import PendingOutgoingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/PendingOutgoingMailLink";
import ReadableIncomingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/ReadableIncomingMailLink";
import ReadableOutgoingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/ReadableOutgoingMailLink";
import RecipientIncomingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/RecipientIncomingMailLink";
import UnclassifiedIncomingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/UnclassifiedIncomingMailLink";
import UnclassifiedOutgoingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/UnclassifiedOutgoingMailLink";
import UnprocessedOutgoingMailLink from "./containers/_Widgets/CustomWidgetLinks/ManageMailLinks/UnprocessedOutgoingMailLink";
import MyClientTeamNoPendingApprovalsLink from "./containers/_Widgets/CustomWidgetLinks/MyClientTeamPendingApprovalsLinks/MyClientTeamNoPendingApprovalsLink";
import MyClientTeamAbsencesLink from "./containers/_Widgets/CustomWidgetLinks/MyClientTeamPendingApprovalsLinks/MyClientTeamPendingAbsencesLink";
import MyClientTeamPendingExpenseClaimsLink from "./containers/_Widgets/CustomWidgetLinks/MyClientTeamPendingApprovalsLinks/MyClientTeamPendingExpenseClaimsLink";
import MyClientTeamPresenceAndLeavesCalendarLink from "./containers/_Widgets/CustomWidgetLinks/MyClientTeamPresenceAndLeavesLinks/MyClientTeamPresenceAndLeavesCalendarLink";
import MyClientTeamPresenceAndLeavesDashboardLink from "./containers/_Widgets/CustomWidgetLinks/MyClientTeamPresenceAndLeavesLinks/MyClientTeamPresenceAndLeavesDashboardLink";
import MyClientTeamPresenceAndLeavesVacationTrackingLink from "./containers/_Widgets/CustomWidgetLinks/MyClientTeamPresenceAndLeavesLinks/MyClientTeamPresenceAndLeavesVacationTrackingLink";
import MyDataLink from "./containers/_Widgets/CustomWidgetLinks/MyDataLinks/MyDataLink";
import MyDataLinkAsFooter from "./containers/_Widgets/CustomWidgetLinks/MyDataLinks/MyDataLinkAsFooter";
import MyDocumentsLink from "./containers/_Widgets/CustomWidgetLinks/MyDocumentsLinks/MyDocumentsLink";
import MyDocumentsLinkAsFooter from "./containers/_Widgets/CustomWidgetLinks/MyDocumentsLinks/MyDocumentsLinkAsFooter";
import MyPayslipsLink from "./containers/_Widgets/CustomWidgetLinks/MyPayslipsLinks/MyPayslipsLink";
import MyReviewedPoliciesLink from "./containers/_Widgets/CustomWidgetLinks/MyPoliciesLinks/MyReviewedPoliciesLink";
import MyUnreviewedPoliciesLink from "./containers/_Widgets/CustomWidgetLinks/MyPoliciesLinks/MyUnreviewedPoliciesLink";
import MyTimesheetLink from "./containers/_Widgets/CustomWidgetLinks/MyPresenceAndLeavesLinks/MyTimesheetLink";
import MyTimesheetLinkAsFooter from "./containers/_Widgets/CustomWidgetLinks/MyPresenceAndLeavesLinks/MyTimesheetLinkAsFooter";
import MyVacationBalanceLink from "./containers/_Widgets/CustomWidgetLinks/MyPresenceAndLeavesLinks/MyVacationBalanceLink";
import DraftLink from "./containers/_Widgets/CustomWidgetLinks/MySurveysLinks/DraftLink";
import NotStartedLink from "./containers/_Widgets/CustomWidgetLinks/MySurveysLinks/NotStartedLink";
import MyTeamMembersLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamConfigurationLinks/MyTeamMembersLink";
import MyTeamPlanningLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamConfigurationLinks/MyTeamPlanningLink";
import MyTeamPayrollOutputReportLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPayrollOutputLinks/MyTeamPayrollOutputReportLink";
import MyTeamPayrollRunLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPayrollOutputLinks/MyTeamPayrollRunLink";
import MyTeamNoPendingApprovalsLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPendingApprovalsLinks/MyTeamNoPendingApprovalsLink";
import MyTeamAbsencesLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPendingApprovalsLinks/MyTeamPendingAbsencesLink";
import MyTeamPendingExpenseClaimsLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPendingApprovalsLinks/MyTeamPendingExpenseClaimsLink";
import MyTeamPresenceAndLeavesFooter from "./containers/_Widgets/CustomWidgetLinks/MyTeamPresenceAndLeavesLinks/MyTeamPresenceAndLeavesFooter";
import MyTeamPresenceAndLeavesFooterOverview from "./containers/_Widgets/CustomWidgetLinks/MyTeamPresenceAndLeavesLinks/MyTeamPresenceAndLeavesFooterOverview";
import MyTeamTimesheetCompletionLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPresenceAndLeavesLinks/MyTeamTimesheetCompletionLink";
import MyTeamTimesheetSignOffLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPresenceAndLeavesLinks/MyTeamTimesheetSignOffLink";
import MyTeamVacationBalanceLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPresenceAndLeavesLinks/MyTeamVacationBalanceLink";
import MyTeamWorkedTimeLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamPresenceAndLeavesLinks/MyTeamWorkedTimeLink";
import MyTeamAssignedEmployeesLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamProjectAssignmentsLinks/MyTeamAssignedEmployeesLink";
import MyTeamProjectAssignmentsInProgressLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamProjectAssignmentsLinks/MyTeamProjectAssignmentsInProgressLink";
import MyTeamAllTravelAndExpensesLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamTravelAndExpensesLinks/MyTeamAllTravelAndExpensesLink";
import MyTeamOpenTravelAndExpensesLink from "./containers/_Widgets/CustomWidgetLinks/MyTeamTravelAndExpensesLinks/MyTeamOpenTravelAndExpensesLink";
import MyTravelAndExpenseInProgressLink from "./containers/_Widgets/CustomWidgetLinks/MyTravelAndExpensesLinks/InProgressLink";
import MyTravelAndExpensePendingApprovalsLink from "./containers/_Widgets/CustomWidgetLinks/MyTravelAndExpensesLinks/MyPendingApprovalsLink";
import AddNewDocument from "./containers/AddNewDocument/AddNewDocument";
import { TEAM_PRESENCE_AND_LEAVES } from "./containers/MyTeamPresenceAndLeaves/MyTeamPresenceAndLeaves";
import { PENDING_APPROVALS_ROUTES } from "./containers/MyTeamProjectAssignments/ProjectAssignmentsPendingApprovals/ProjectAssignmentsPendingApprovals";
import { ComplianceRoutes } from "./views/documents-reports/ComplianceDocuments/ComplianceDocuments";

import { ManageMailRoutes } from "./views/manage-mail/ManageMail";
import { ACTIVE_HIRING_CLIENT_ROUTES } from "./views/recruiting/Recruiting";

export const ComplianceDocumentsLinks = {
  Compliance: {
    id: "1626cdc1-1471-45a4-b6c3-4b9dbaa5f94e",
    translationKey: "fiscal_year_compliance",
    route: `compliance-documents?tab=${ComplianceRoutes.COMPLIANCE}`,
  },
  Assemblies: {
    id: "89adb159-4e3e-4dc3-b095-0f92b294ceff",
    translationKey: "assemblies_audits_corporate_changes",
    route: `compliance-documents?tab=${ComplianceRoutes.ASSEMBLIES}`,
  },
  Registrations: {
    id: "b1f06ecb-2058-41ec-80be-421f6608d1b2",
    translationKey: "registrations_documents_ids_poas",
    route: `compliance-documents?tab=${ComplianceRoutes.REGISTRATIONS}`,
  },
  Passwords: {
    id: "ea5344a1-912b-4038-97c2-303a51adb201",
    translationKey: "passwords",
    route: `compliance-documents?tab=${ComplianceRoutes.PASSWORDS}`,
  },
  CompanyAccountDocuments: {
    id: "15936a67-dfdc-4f4c-83ae-bc6aa1f22c76",
    translationKey: "company_documents",
    route: "company-documents",
  },
  CompanyAccountOverview: {
    id: "2878f6a3-3c92-4c29-beb2-a0953018b9a4",
    translationKey: "company_account_overview",
    route: "company-account-overview",
  },
  LegalEntityAdministrativeProcess: {
    id: "f06a7c8a-5693-49d1-ab75-06ce29df7f8b",
    translationKey: "legal_entity_administrative_process",
    route: "legal-entity-administrative-process",
  },
  ArchiveDownload: {
    id: "090f4bb5-764e-4dc8-939a-f8d4df9e6a6e",
    translationKey: "archive_download",
    route: "archive-download",
  },
};

export const AccountingOutputLinks = {
  AccountingDocuments: {
    id: "e1914e50-167c-40d9-b8cd-0ffa81dfc209",
    translationKey: "accounting_documents",
    route: "accounting-documents",
  },
  AccountingCalendar: {
    id: "9e288e62-018e-4fd1-9b94-efbe310bfef7",
    translationKey: "accounting_calendar",
    route: "accounting-calendar",
  },
};

export const SystemConfigurationLinks = {
  TnACalendars: {
    id: "97fffc3d-5ca7-4fcd-85aa-3d923c300241",
    translationKey: "tna_calendars",
    route: "tna-calendars",
  },
  MaintainExchangeRates: {
    id: "9f472079-2840-428a-9153-2fb92ea9d52c",
    translationKey: "exchange_rates",
    route: "system-settings/system-configuration/exchange-rates",
  },
};

export const MyTeamPresenceAndLeavesLinks = {
  MyTeamPresenceAndLeaves: {
    id: "80041536-d0f4-4a28-9802-3a06a3089fa2",
    translationKey: "dashboard",
    route: "my-team-presence-and-leaves",
  },
  VacationBalance: {
    id: "80041536-d0f4-4a28-9802-3a06a3089fa2",
    translationKey: "vacation_balance",
    route: "my-team-presence-and-leaves?tab=vacation-tracking",
    CustomLink: MyTeamVacationBalanceLink,
    customStyle: {
      width: "100%",
    },
    tabRoute: TEAM_PRESENCE_AND_LEAVES.VACATION_TRACKING,
  },
  WorkedTime: {
    id: "80041536-d0f4-4a28-9802-3a06a3089fa2",
    translationKey: "worked_time",
    route: "my-team-presence-and-leaves?tab=worked-time",
    CustomLink: MyTeamWorkedTimeLink,
    customStyle: {
      width: "100%",
    },
    tabRoute: TEAM_PRESENCE_AND_LEAVES.WORKED_TIME,
  },
  Dashboard: {
    id: "80041536-d0f4-4a28-9802-3a06a3089fa2",
    translationKey: "timesheet_completion",
    route: "my-team-presence-and-leaves?tab=dashboard",
    CustomLink: MyTeamTimesheetCompletionLink,
    customStyle: {
      width: "100%",
    },
    tabRoute: TEAM_PRESENCE_AND_LEAVES.TEAM_PRESENCE_AND_LEAVES_OVERVIEW,
  },
  TimesheetSignoff: {
    id: "80041536-d0f4-4a28-9802-3a06a3089fa2",
    translationKey: "timesheet_confirmation",
    route: "my-team-presence-and-leaves?tab=timesheet-confirmation",
    CustomLink: MyTeamTimesheetSignOffLink,
    customStyle: {
      width: "100%",
    },
    tabRoute: TEAM_PRESENCE_AND_LEAVES.TIME_SHEET_CONFIRMATION,
  },
  ExtraHours: {
    id: "80041536-d0f4-4a28-9802-3a06a3089fa2",
    translationKey: "extra_hours",
    route: "my-team-presence-and-leaves?tab=extra-hours",
    CustomLink: MyTeamPresenceAndLeavesFooter,
    asFooter: true,
    customStyle: {
      width: "100%",
      justifyContent: "end",
    },
    displayOnlyInDashboard: true,
    tabRoute: TEAM_PRESENCE_AND_LEAVES.EXTRA_HOURS,
  },
  Overview: {
    id: "80041536-d0f4-4a28-9802-3a06a3089fa2",
    translationKey: "dashboard",
    route: "my-team-presence-and-leaves?tab=dashboard",
    CustomLink: MyTeamPresenceAndLeavesFooterOverview,
    asFooter: true,
    customStyle: {
      width: "100%",
    },
    tabRoute: TEAM_PRESENCE_AND_LEAVES.TEAM_PRESENCE_AND_LEAVES_OVERVIEW,
  },
};

export const MyClientTeamPresenceAndLeavesLinks = {
  MyClientTeamPresenceAndLeaves: {
    id: "4e1fb1a0-4bfb-4927-9c76-5c4080459af6",
    translationKey: "overview",
    route: "my-client-team-presence-and-leaves",
  },
  Dashboard: {
    id: "4e1fb1a0-4bfb-4927-9c76-5c4080459af6",
    translationKey: "timesheets",
    route: "my-client-team-presence-and-leaves",
    CustomLink: MyClientTeamPresenceAndLeavesDashboardLink,
  },
  Calendar: {
    id: "4e1fb1a0-4bfb-4927-9c76-5c4080459af6",
    translationKey: "calendar",
    route: "my-client-team-presence-and-leaves",
    CustomLink: MyClientTeamPresenceAndLeavesCalendarLink,
  },
  VacationTracking: {
    id: "4e1fb1a0-4bfb-4927-9c76-5c4080459af6",
    translationKey: "vacation_tracking",
    route: "my-client-team-presence-and-leaves",
    CustomLink: MyClientTeamPresenceAndLeavesVacationTrackingLink,
  },
};

export const MyClientTeamPendingApprovalsLinks = {
  NoPendingApprovalsLink: {
    id: "af7ff14f-c29e-4101-aee3-0207146f8e21",
    translationKey: "pending_approvals",
    route: "my-client-team-pending-approvals",
    CustomLink: MyClientTeamNoPendingApprovalsLink,
    customStyle: {
      width: "100%",
    },
  },
  Absences: {
    id: "af7ff14f-c29e-4101-aee3-0207146f8e21",
    translationKey: "absences",
    route: "my-client-team-pending-approvals",
    CustomLink: MyClientTeamAbsencesLink,
    customStyle: {
      width: "100%",
    },
  },
  ExpenseClaims: {
    id: "af7ff14f-c29e-4101-aee3-0207146f8e21",
    translationKey: "expenses_claims",
    route: "my-client-team-pending-approvals",
    CustomLink: MyClientTeamPendingExpenseClaimsLink,
    customStyle: {
      width: "100%",
    },
  },
};

export const MyTeamPendingApprovalsLinks = {
  PendingApprovals: {
    id: "bf7ff14f-c29e-4101-aee3-0207146f8e24",
    translationKey: "pending_approvals",
    route: "my-team-pending-approvals",
  },
  NoPendingApprovalsLink: {
    id: "bf7ff14f-c29e-4101-aee3-0207146f8e24",
    // translationKey: "pending_approvals",
    route: "my-team-pending-approvals",
    CustomLink: MyTeamNoPendingApprovalsLink,
    customStyle: {
      width: "100%",
    },
  },
  Absences: {
    id: "bf7ff14f-c29e-4101-aee3-0207146f8e24",
    translationKey: "absences",
    route: "my-team-pending-approvals?tab=absences",
    CustomLink: MyTeamAbsencesLink,
    customStyle: {
      width: "100%",
    },
    tabRoute: PENDING_APPROVALS_ROUTES.ABSENCES,
  },
  ExpenseClaims: {
    id: "bf7ff14f-c29e-4101-aee3-0207146f8e24",
    translationKey: "expenses_claims",
    route: "my-team-pending-approvals?tab=expense-reports",
    CustomLink: MyTeamPendingExpenseClaimsLink,
    customStyle: {
      width: "100%",
    },
    tabRoute: PENDING_APPROVALS_ROUTES.EXPENSE_REPORTS,
  },
};

export const MyTeamProjectAssignmentLinks = {
  Overview: {
    id: "5bd48729-65f3-404e-836a-5fe0d2746a62",
    translationKey: "overview",
    route: "my-team-project-assignments",
  },
  InProgress: {
    id: "5bd48729-65f3-404e-836a-5fe0d2746a62",
    translationKey: "in_progress",
    route: "my-team-project-assignments",
    CustomLink: MyTeamProjectAssignmentsInProgressLink,
  },
  AssignedEmployees: {
    id: "5bd48729-65f3-404e-836a-5fe0d2746a62",
    translationKey: "assigned_employees",
    route: "my-team-project-assignments",
    CustomLink: MyTeamAssignedEmployeesLink,
  },
};

export const MyTeamPayrollOutput = {
  MyTeamPayrollOutputReport: {
    id: "2cbe18cc-a0e2-4a6b-9317-ce0e1bd71ce8",
    translationKey: "payroll_output_report",
    route: "payroll-output-report",
    CustomLink: MyTeamPayrollOutputReportLink,
    customStyle: {
      width: "100%",
    },
  },
  MyTeamPayrollCalendar: {
    id: "10c23c58-9c50-4a0d-8896-fe719bfb9bb1",
    translationKey: "my_team_payroll_calendar",
    route: "my-team-payroll-runs?tab=calendar",
    CustomLink: MyTeamPayrollRunLink,
    customStyle: {
      width: "100%",
    },
  },
};

export const MyTeamTravelAndExpensesLinks = {
  ManageTravelAndExpenses: {
    id: "bf7138a1-caba-44cd-b258-b9c30fbbcd91",
    route: "manage-travel-and-expenses",
  },
  ManageOpenTravelAndExpenses: {
    id: "bf7138a1-caba-44cd-b258-b9c30fbbcd91",
    translationKey: "manage_travel_and_expenses",
    route: "manage-travel-and-expenses",
    CustomLink: MyTeamOpenTravelAndExpensesLink,
    customStyle: {
      width: "100%",
      justifyContent: "center",
      marginTop: "15%",
    },
  },
  ManageAllTravelAndExpenses: {
    id: "bf7138a1-caba-44cd-b258-b9c30fbbcd91",
    translationKey: "manage_travel_and_expenses",
    route: "manage-travel-and-expenses",
    CustomLink: MyTeamAllTravelAndExpensesLink,
    asFooter: true,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
};

export const MyTravelAndExpensesLinks = {
  TravelAndExpenses: {
    id: "ada0801e-0e30-4e07-89a4-c0d478562c93",
    route: "my-travel-and-expenses",
  },
  // TravelAndExpensesInProgress: {
  //   id: "ada0801e-0e30-4e07-89a4-c0d478562c93",
  //   translationKey: "my_travel_and_expenses",
  //   route: "my-travel-and-expenses?inProgress=true",
  //   CustomLink: MyTravelAndExpenseInProgressLink,
  // },
  // TravelAndExpensesPending: {
  //   id: "ada0801e-0e30-4e07-89a4-c0d478562c93",
  //   translationKey: "my_travel_and_expenses",
  //   route: "my-travel-and-expenses?pending=true",
  //   CustomLink: MyTravelAndExpensePendingApprovalsLink,
  // },
  TravelAndExpensesInProgress: {
    id: "ada0801e-0e30-4e07-89a4-c0d478562c93",
    translationKey: "my_travel_and_expenses",
    route: "my-travel-and-expenses",
    CustomLink: MyTravelAndExpenseInProgressLink,
  },
  TravelAndExpensesPending: {
    id: "ada0801e-0e30-4e07-89a4-c0d478562c93",
    translationKey: "pending_approvals",
    route: "my-travel-and-expenses",
    CustomLink: MyTravelAndExpensePendingApprovalsLink,
    displayOnlyInDashboard: true,
  },
};

export const PayrollOutputLinks = {
  PayrollDocument: {
    id: "3b4e29ea-7f16-4fcd-914c-ac007fd70269",
    translationKey: "payroll_documents",
    route: "payroll-documents",
  },
  PayrollCalendar: {
    id: "06174da0-4ecd-44f6-8053-cf1fce129e40",
    translationKey: "payroll_calendar",
    route: "payroll-runs?tab=calendar",
  },
  ProvidePayrollInput: {
    id: "0ed61361-7aab-4bc2-97ae-fae9b6dfa884",
    translationKey: "provide_payroll_inputs",
    route: "provide-payroll-inputs",
  },
};

export const PoliciesLinks = {
  Policies: {
    id: "74e998af-76d7-4f4d-b147-f0c8c7b7c459",
    route: "view-policies",
  },
  // ViewReviewedPolicies: {
  //   id: "74e998af-76d7-4f4d-b147-f0c8c7b7c459",
  //   translationKey: "view_policies",
  //   route: "view-policies?reviewed=true",
  //   CustomLink: MyReviewedPoliciesLink,
  // },
  // ViewUnreviewedPolicies: {
  //   id: "74e998af-76d7-4f4d-b147-f0c8c7b7c459",
  //   translationKey: "view_policies",
  //   route: "view-policies?reviewed=false",
  //   CustomLink: MyUnreviewedPoliciesLink,
  // },
  ViewReviewedPolicies: {
    id: "74e998af-76d7-4f4d-b147-f0c8c7b7c459",
    translationKey: "view_policies",
    route: "view-policies",
    CustomLink: MyReviewedPoliciesLink,
  },
  ViewUnreviewedPolicies: {
    id: "74e998af-76d7-4f4d-b147-f0c8c7b7c459",
    translationKey: "pending_policy_reviews",
    route: "view-policies",
    CustomLink: MyUnreviewedPoliciesLink,
    displayOnlyInDashboard: true,
  },
};

export const PoliciesManagmentLinks = {
  ManagePolicies: {
    id: "e089d5a8-eb81-4a70-a226-e7b48a1a9028",
    translationKey: "manage_policies",
    route: "manage-policies",
    summaryField: "numberOfCompanyPoliciesToReview",
  },
};

export const MyPresenceAndLeavesLinks = {
  MyLeaves: {
    id: "8137a100-c18c-4693-acad-677ff5d0447a",
    translationKey: "my_leaves",
    route: "my-leaves",
    CustomLink: MyVacationBalanceLink,
  },
  MyTimesheet: {
    id: "5b6c1066-7da2-4366-86f2-f94759baddf6",
    translationKey: "clock_in_out",
    route: "my-t-and-a",
    CustomLink: MyTimesheetLink,
  },
  MyTimesheetAsFooter: {
    id: "5b6c1066-7da2-4366-86f2-f94759baddf6",
    translationKey: "clock_in_out",
    route: "my-t-and-a",
    asFooter: true,
    CustomLink: MyTimesheetLinkAsFooter,
    displayOnlyInDashboard: true,
  },
};

export const ProccessDocumentsLinks = {
  IncomingDocuments: {
    id: "9ad74896-df55-47ec-b5d2-b6962062e6a7",
    translationKey: "incoming_documents",
    route: "incoming-documents",
    summaryField: "documentsSummaryTotal",
  },
  AllDocuments: {
    id: "5e474410-453b-47f8-a7f3-ff1bf9d75a60",
    translationKey: "all_documents",
    route: "all-documents",
  },
};

export const QuestionsAndRequestsLinks = {
  AllClarifications: {
    id: "cc93ca4a-1260-4516-a1ea-5ca0d22e243f",
    translationKey: "all_clarifications",
    route: "all-clarifications",
  },
};

export const RecruitingLinks = {
  HiringClients: {
    id: "eebb7463-7f5d-4c0d-8b48-8d52f1b2df52",
    translationKey: "active_hiring_clients",
    route: "recruiting?tab=hiring-clients",
    summaryField: "numberOfActiveHiringClients",
    tabRoute: ACTIVE_HIRING_CLIENT_ROUTES.HIRING_CLIENTS,
  },
  Positions: {
    id: "0f3bded6-eb23-4311-9b52-03f6c8f4e188",
    translationKey: "active_positions",
    route: "recruiting?tab=open-positions",
    summaryField: "numberOfOpenPositions",
    tabRoute: ACTIVE_HIRING_CLIENT_ROUTES.OPEN_POSITIONS,
  },
  Candidates: {
    id: "7c02a27c-1cac-463b-aa98-0bcb1eb27884",
    translationKey: "candidates_in_process",
    route: "recruiting?tab=candidates",
    summaryField: "numberOfCandidatesInProcess",
    tabRoute: ACTIVE_HIRING_CLIENT_ROUTES.CANDIDATES,
  },
};

export const UserManagementLinks = {
  UserAccessRights: {
    id: "55c55d1f-f343-4f63-b458-d8565fb3b613",
    translationKey: "user_access_rights",
    route: "user-access-rights",
  },
  AccessToCompanyAccounts: {
    id: "f4004a3d-1df2-44e5-af7b-6291c430cabc",
    translationKey: "access_to_company_accounts",
    route: "access-to-company-accounts",
  },
  AccessToLegalEntities: {
    id: "b3766bef-1a85-4551-9c46-33eb381b4f6e",
    translationKey: "access_to_legal_entity",
    route: "access-to-legal-entity",
  },
  UserActivity: {
    id: "953462fe-2175-4905-9862-15b60ac48984",
    translationKey: "user_activity",
    route: "user-activity",
  },
  GeneralRulesForUsers: {
    id: "d5af010d-442b-4a5f-b4b9-e90017efc856",
    translationKey: "general_rules_for_users",
    route: "general-rules-for-users",
  },
};

export const SendUsLinks = {
  NewDocument: {
    id: "5df4e4f0-29b2-449c-b8c4-aac63f8221aa",
    translationKey: "add_new_document.button_content",
    route: "send-us",
    children: (
      <AddNewDocument
        openButtonKey={"components.widgets.send_us.children.add_new_document.button_content"}
        isWidget
        linkStyles
        withLastDocs
      />
    ),
  },
  PayrollInputs: {
    id: "1702a1af-f74d-436d-a134-11a3870b9d90",
    translationKey: "payroll_instruction",
    route: "payroll-inputs?tab=payroll-inputs",
  },
  AccountingInput: {
    id: "fb2a162f-3e10-4bab-a727-f11d0906f9f0",
    translationKey: "accounting_instruction",
    route: "accounting-inputs?tab=accounting-input",
  },
};

export const ConfigureCompanyAccountLinks = {
  LegalEntities: {
    id: "afb203ee-137d-411b-81bc-9eade7c6ba22",
    translationKey: "legal_entities",
    route: "legal-entities",
  },
  EmployeeGroups: {
    id: "c3b12755-838d-49e5-847e-1c14565fa19d",
    translationKey: "employee_groups",
    route: "employee-groups",
  },
  VisibleEeDocuments: {
    id: "4931b1ad-684a-427c-8a03-67544592250a",
    translationKey: "visible_employee_documents",
    route: "legal-entities?tab=visible-employee-documents",
  },
  ManageProjects: {
    id: "58cba30a-887f-4508-ab71-5ab74ede5298",
    translationKey: "manage_projects",
    route: "employees?tab=projects",
  },
  TnARules: {
    id: "e262cf58-e1ba-4c24-8a4f-29c056943cf0",
    translationKey: "time_and_absences_rules",
    route: "time-and-absences-rules",
  },
  Preferences: {
    id: "e8ea72b6-6149-4f24-9807-12ccdf0027ff",
    translationKey: "preferences",
    route: "preferences",
  },
  ConsolidationGroups: {
    id: "8ce0092a-bcce-4223-876b-b4aa4079c429",
    translationKey: "consolidation_groups",
    route: "consolidation-groups",
  },
};

export const MyDocumentsLinks = {
  Documents: {
    id: "3ec4bd4b-5307-49c9-8eb9-f0f738757f93", //new ID
    translationKey: "my_documents",
    route: "my-personal-documents",
    // asFooter: true,
    CustomLink: MyDocumentsLink,
    customStyle: {
      width: "100%",
      height: "100%",
      padding: 0,
    },
  },
  DocumentsAsFooter: {
    id: "3ec4bd4b-5307-49c9-8eb9-f0f738757f93", //new ID
    translationKey: "my_documents",
    route: "my-personal-documents",
    asFooter: true,
    CustomLink: MyDocumentsLinkAsFooter,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
};

export const MyPayslipsLinks = {
  Documents: {
    id: "3ec4bd4b-5307-49c9-8eb9-f0f738757f93",
    translationKey: "my_payslips",
    route: "my-personal-documents",
    asFooter: true,
    CustomLink: MyPayslipsLink,
    customStyle: {
      width: "100%",
    },
  },
};

// export const MyDataLinks = {
//   Data: {
//     id: "a0779e0b-8f98-4755-b522-b4753a849fe9",
//     translationKey: "my_data",
//     route: "my-data",
//     asFooter: true,
//     CustomLink: MyDataLink,
//     customStyle: {
//       width: "100%",
//     },
//   },
// };

export const MyDataLinks = {
  Data: {
    id: "a0779e0b-8f98-4755-b522-b4753a849fe9",
    translationKey: "my_data",
    route: "my-data",
    // asFooter: true,
    CustomLink: MyDataLink,
    customStyle: {
      width: "100%",
    },
  },
  DataAsFooter: {
    id: "a0779e0b-8f98-4755-b522-b4753a849fe9",
    translationKey: "my_data",
    route: "my-data",
    asFooter: true,
    CustomLink: MyDataLinkAsFooter,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
};

export const ProcessAccountingLinks = {
  PrepareAccInput: {
    id: "1c55e977-56da-4765-93d5-77fdaf7ee173",
    translationKey: "prepare_acc_input",
    route: "accounting-inputs?tab=accounting-input",
  },
  // { TBD later
  //   id: "b1d5496d-20d0-431b-b8b3-591bcb8bd441",
  //   translationKey: "verify_acc_output", route: "verify-acc-output"
  // },
  AccountingMasterData: {
    id: "fdb7d93d-0466-4cbd-9f9f-8d2cab25f695",
    translationKey: "accounting_master_data",
    route: "accounting-master-data?tab=clients",
  },
  InvoiceTracking: {
    id: "9e9dd4ea-8c59-40b7-a9a5-5c9c78e605b0",
    translationKey: "invoice_tracking",
    route: "invoice-tracking",
  },
  TransactionForecast: {
    id: "273467a8-7308-477a-8be6-f620c4931f46",
    translationKey: "transactions_forecasts",
    route: "transactions-forecasts?tab=transactions",
  },
  BankAndCash: {
    id: "2475167c-912e-4893-9ab8-add6de81841a",
    translationKey: "bank_and_cash",
    route: "bank-and-cash",
  },
  PnlReport: {
    id: "949e9554-df66-4f78-a2cf-b56087575224",
    translationKey: "pnl_report",
    route: "pnl-report",
  },
  EmployeeReport: {
    id: "c2860f90-aca6-4885-8731-77f65ee7d2dc",
    translationKey: "employee_report",
    route: "employee-report",
  },
  // {
  //   id: "e6ea2ac1-f74d-4e56-8832-69d27d91e0c6",
  //   translationKey: "pnl_and_bs", route: "pnl-and-bs"
  // },
};

export const ProcessEmploymentAndPayrollLinks = {
  EmployeeList: {
    id: "aac27b6e-c75f-423e-b781-6323ec85e583",
    translationKey: "employee_list",
    route: "employees?tab=employees-dashboard",
  },
  EmployeeReport: {
    id: "a816ff67-aa73-47a6-ae94-c7b67d6e252e",
    translationKey: "employee_report",
    route: "employee-report",
  },
  PayrollInputs: {
    id: "be3036da-ad43-4102-8f95-93f31f59654d",
    translationKey: "payroll_inputs",
    route: "payroll-inputs?tab=payroll-inputs",
    //route: "prepare-payroll-mutations",
  },
  Mutations: {
    id: "4ebc5d32-eb2a-46c2-9fe3-58be543be873",
    translationKey: "prepare_payroll_mutations",
    route: "mutations?tab=employee-mutations",
    //route: "prepare-payroll-mutations",
  },
  VerifyPayrollOutput: {
    id: "61f2c2cb-f59e-4679-b390-1b0b649d69d6",
    translationKey: "verify_payroll_output",
    route: "verify-payroll-output",
  },
  ManagePayrollRuns: {
    id: "39bdc83f-cc8e-40dc-82de-e71465342214",
    translationKey: "manage_payroll_runs",
    route: "payroll-runs?tab=runs",
  },
  ProformaEmployeeCostReport: {
    id: "57b1de95-406e-4276-af4b-942d5ee52a3d",
    translationKey: "proforma_employee_cost_report",
    route: "employee-cost?tab=proforma-employee-cost-report",
  },
  SplitEmployeeDocument: {
    id: "b493fec1-50de-4032-8773-96819fe200f5",
    translationKey: "upload_and_split_employee_pdf",
    route: "split-employee-document",
  },
};

export const MyTeamDocumentsLinks = {
  MyTeamDocuments: {
    id: "dfe9eb12-ee62-4d2e-badf-61c15bb71342",
    translationKey: "my_team_documents",
    route: "my-team-employees-documents",
  },
};

export const ManagerAlertLines = {
  ManageAlertLines: {
    id: "6d47e974-fc79-4ad8-a404-ef44a37a28dc",
    route: "manage-alert-line-reports",
  },
  PendingAlertLineReports: {
    id: "6d47e974-fc79-4ad8-a404-ef44a37a28dc",
    translationKey: "manage_alert_lines",
    route: "manage-alert-line-reports",
    CustomLink: PendingAlertLineLink,
    displayOnlyInDashboard: true,
  },
  ClosedAlertLineReports: {
    id: "6d47e974-fc79-4ad8-a404-ef44a37a28dc",
    translationKey: "manage_alert_lines",
    route: "manage-alert-line-reports",
    CustomLink: ClosedAlertLineLink,
    displayOnlyInDashboard: true,
  },
  SubmittedAlertLineReports: {
    id: "6d47e974-fc79-4ad8-a404-ef44a37a28dc",
    translationKey: "manage_alert_lines",
    route: "manage-alert-line-reports",
    asFooter: true,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
    CustomLink: ManageAlertLineFooter,
  },
};

export const SystemAnalyticsLinks = {
  PresenceAndLeavesUsage: {
    id: "5f25624d-e2d1-4734-97ea-47125df82708",
    translationKey: "presense_and_leaves_usage",
    route: "presense-and-leaves-usage",
  },
  EmployeesProcessed: {
    id: "09bcb01e-3ded-4388-b87f-9a4a37073e59",
    translationKey: "employees_processed",
    route: "employees-processed",
  },
  Users: {
    id: "6c72eb25-bd9c-4122-a941-0293caba77d4",
    translationKey: "users",
    route: "users",
  },
};

export const BusinessAnalyticsLinks = {
  Clients: {
    id: "f9a7e1bb-cc6b-4b89-938c-891b6be3dc27",
    translationKey: "clients",
    route: "clients",
  },
  Compensation: {
    id: "397fc3a0-908e-48cf-a0d3-a1ff69492484",
    translationKey: "compensation",
    route: "compensation",
  },
};

export const AccountManagementLinks = {
  Clients: {
    id: "741105c3-4998-4fb1-9ce6-0f2d83c694cf",
    translationKey: "clients",
    route: "employee-group-clients",
  },
};

export const MyTeamPoliciesLinks = {
  MyTeamPoliciesLinks: {
    id: "84a58903-41dc-47c6-bcec-9ebbbbb47320",
    translationKey: "my_team_policies",
    route: "my-team-policies",
  },
};

export const ManageMailLinks = {
  PendingIncomingMailLink: {
    id: "4cccc720-aa8f-491c-90d8-f2e84d47f01f",
    translationKey: "incoming_mail",
    route: `manage-mail?tab=${ManageMailRoutes.INCOMING}&&via=pending`,
    CustomLink: PendingIncomingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
  IncomingMailForRecipientLink: {
    id: "9eaa4c86-2b48-4fab-a378-0ae6b883a662",
    translationKey: "incoming_mail",
    route: `manage-mail?tab=${ManageMailRoutes.INCOMING}&&via=addressee`,
    CustomLink: RecipientIncomingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
  PendingOutgoingMailLink: {
    id: "456de670-e588-4d6f-bf21-20202634a6b7",
    translationKey: "outgoing_mail",
    route: `manage-mail?tab=${ManageMailRoutes.OUTGOING}&&via=pending`,
    CustomLink: PendingOutgoingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
  MailRecipientsLink: {
    id: "7d3c4be6-0a80-4d4b-b73d-107a1838f721",
    translationKey: "letter_addressees",
    route: `manage-mail?tab=${ManageMailRoutes.RECIPIENTS}`,
    CustomLink: ManageLetterAddresseesLink,
    asHeaderLink: true,
    displayOnlyInDashboard: true,
  },
  UnclassifiedIncomingMailLink: {
    id: "09405264-fe51-4164-825b-eb29c10b0a5f",
    translationKey: "unclassified",
    route: `manage-mail?tab=${ManageMailRoutes.INCOMING}&&via=unclassified`,
    CustomLink: UnclassifiedIncomingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
  UnclassifiedOutgoingMailLink: {
    id: "5108e869-8a39-4e96-b609-08eab224076d",
    translationKey: "unclassified",
    route: `manage-mail?tab=${ManageMailRoutes.OUTGOING}&&via=unclassified`,
    CustomLink: UnclassifiedOutgoingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
  NoPendingMailIncomingLink: {
    id: "08bfdb8a-0503-4c63-a11f-308bb4c88194",
    translationKey: "no_pending_mail",
    route: `manage-mail?tab=${ManageMailRoutes.INCOMING}`,
    CustomLink: NoPendingMailsLink,
    customStyle: {
      width: "100%",
      justifyContent: "center",
    },
    displayOnlyInDashboard: true,
  },
  NoPendingMailOutgoingLink: {
    id: "0e85759c-c2a4-4e84-82da-4e23b4d5c6c9",
    translationKey: "no_pending_mail",
    route: `manage-mail?tab=${ManageMailRoutes.OUTGOING}`,
    CustomLink: NoPendingMailsLink,
    customStyle: {
      width: "100%",
      justifyContent: "center",
    },
    displayOnlyInDashboard: true,
  },
  UnprocessedOutgoingMailLink: {
    id: "e0e78c80-9a6f-423f-aa86-975bc1720731",
    translationKey: "unprocessed",
    route: `manage-mail?tab=${ManageMailRoutes.OUTGOING}`,
    CustomLink: UnprocessedOutgoingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
  ReadableIncomingMailLink: {
    id: "f06a2f2c-a360-4a39-b402-9c8805bf7061",
    translationKey: "incoming_mail",
    route: `manage-mail?tab=${ManageMailRoutes.INCOMING}`,
    CustomLink: ReadableIncomingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
  ReadableOutgoingMailLink: {
    id: "d4005150-d99e-4fac-b955-267e595a320e",
    translationKey: "outgoing_mail",
    route: `manage-mail?tab=${ManageMailRoutes.OUTGOING}`,
    CustomLink: ReadableOutgoingMailLink,
    customStyle: {
      width: "100%",
    },
    displayOnlyInDashboard: true,
  },
};

export const HelpAndTipsLinks = {
  OpenProviderPopupsLink: {
    id: "6f04879e-e427-420b-b649-0fa6a5c01a20",
    translationKey: "open_popups",
    route: "manage-provider-site-advertisement-popups",
    CustomLink: OpenProviderPopupsLink,
  },
  RanOutOfPopups: {
    id: "6f04879e-e427-420b-b649-0fa6a5c01a20",
    translationKey: "ran_out_of_popups",
    route: "manage-provider-site-advertisement-popups",
    CustomLink: RanOutOfPopusLink,
  },
};

export const EmployeeSurveysLink = {
  OpenSurveys: {
    id: "1ad7d7ec-33cc-4ef6-9843-ef10bac61ee5",
    translationKey: "open",
    route: "manage-employee-surveys",
    CustomLink: OpenSurveysLink,
  },
  ProgressingSlowly: {
    id: "1ad7d7ec-33cc-4ef6-9843-ef10bac61ee5",
    translationKey: "progressing_slowly",
    route: "manage-employee-surveys",
    CustomLink: ProgressingSlowlyLink,
  },
};

export const MySurveys = {
  NotStarted: {
    id: "bfe8b6b7-3e4d-4294-8ae4-cb427ee6731f",
    translationKey: "not_started",
    route: "my-surveys",
    CustomLink: NotStartedLink,
  },
  Draft: {
    id: "bfe8b6b7-3e4d-4294-8ae4-cb427ee6731f",
    translationKey: "draft",
    route: "my-surveys",
    CustomLink: DraftLink,
  },
};

export const ClockingLocationQRCodeLinks = {
  GenerateCode: {
    id: "d2c74fac-740b-4345-b539-bc552fd758c3",
    translationKey: "generate_code",
    route: "generate-clocking-location-qr-code",
  },
};

export const DocumentTemplatesLinks = {
  AddTemplate: {
    id: "a1234567-89ab-cdef-0123-456789abcdef",
    translationKey: "manage_templates",
    route: "document-templates",
  },
};

export const MyTeamConfigurationLinks = {
  TeamMembers: {
    id: "97eaa514-3056-446e-b1e5-ceaad34de435", // Both links have same ID
    translationKey: "team_members",
    route: "my-team-configuration?tab=team-members",
    CustomLink: MyTeamMembersLink,
  },
  TeamPlanning: {
    id: "97eaa514-3056-446e-b1e5-ceaad34de435",
    translationKey: "team_planning",
    route: "my-team-configuration?tab=team-planning",
    CustomLink: MyTeamPlanningLink,
  },
};

export const CorporateStructureLinks = {
  ShareholdersList: {
    id: "cc0ab686-b14d-463f-8ae0-e1a8321d825c",
    translationKey: "shareholders_list",
    route: "shareholders-list",
  },
  PowerOfAttorneys: {
    id: "1b8e382b-f13e-4552-a1c8-39222a634f98",
    translationKey: "power_of_attorneys",
    route: "power-of-attorneys",
  },
};

export const IndividualsLinks = {
  Individuals: {
    id: "6dfe00bd-db99-46d7-a816-1363cac8343d",
    translationKey: "individuals",
    route: "individuals",
  },
};

export const DocumentSignatureLinks = {
  ManageDocumentsToSign: {
    id: "caeb1092-240c-456f-af7f-763efa573754",
    translationKey: "manage_documents_to_sign",
    route: "manage-documents-to-sign",
    CustomLink: ManageDocumentSignatureLink,
    customStyle: {
      width: "100%",
    },
  },
  MyDocumentsToSign: {
    id: "825cc189-009e-4bf8-b730-e0c9f9c9123f",
    translationKey: "my_documents_to_sign",
    route: "my-documents-to-sign",
    CustomLink: MyDocumentsToSignLink,
    customStyle: {
      width: "100%",
    },
  },
};

export const MyTeamLinks = {
  ClockingLocationCodes: {
    id: "e94389f2-ff3c-4f07-b015-2ce12e94ef1a",
    translationKey: "tna_location_codes",
    route: "clocking-location-codes",
  },
  PerformanceReviews: {
    id: "a3adbab3-017d-40a1-8259-3a83715f4795",
    translationKey: "performance_reviews",
    route: "performance-reviews",
  },
};
